export class AccountApproveVarianceCommand{
    caseId:string;
    approvalStatus:string;

    constructor(caseId:string, approvalStatus:string){
        this.caseId = caseId;
        this.approvalStatus = approvalStatus;
    }
}